import React, { useState, useEffect } from "react";
import axios from "axios";
import Select from 'react-select'
import { FaUser, FaUserFriends, FaIdBadge } from "react-icons/fa";
import "./Saving.css";
import { fetchUserProfile } from "../../redux/slices/branch/userProfileSlice";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";

const SavingAccountForm = () => {
  const [accountType, setAccountType] = useState("Saving Account");
  const [schemes, setSchemes] = useState([]);
  const [selectedScheme, setSelectedScheme] = useState("");
  const [internetBanking, setInternetBanking] = useState(false);
  const dispatch = useDispatch();
  const { profile } = useSelector((state) => state.userProfile);

  // Customer States
  const [customerId, setCustomerId] = useState("");
 const [customers,setCustomers]=useState([])
  const [selectedCustomer,setSelectedCustomer]=useState(null);
  const [customerData, setCustomerData] = useState({
    name: "",
    email: "",
    phone: "",
    aadhar: "",
    pan: "",
    address: "",
    dob: "",
  });

  const [customerLoading, setCustomerLoading] = useState(false);

  // Nominee States
  const [nomineeId, setNomineeId] = useState("");

  const [nomineeData, setNomineeData] = useState({
    nomineeName: "",
    dob: "",
    aadhar: "",
    pan: "",
    mobile: "",
    address: "",
  });

  const [nomineeLoading, setNomineeLoading] = useState(false);
  const [relation, setRelation] = useState("");

  const [prefixData, setPrefix] = useState("");

  const [idProof, setIdProof] = useState("");

  // Referral
  const [referId, setreferId] = useState("");
  const [referralName, setReferralName] = useState("");
  const [referType,setReferType]=useState(null);

  // Account Form
  const [formData, setFormData] = useState({
    accountType: "Saving Account",
    scheme: "",
    schemeId: 0,
    interestRate: "",
    initialDeposit: "",
    cashWithdrawLimit: "",
    fundTransferLimit: "",
    // LockinAmount: "",
    overdraftLimit: "",
    businessName: "",
    gstNumber: "",
    operationMode: "",
    openingDate: new Date().toISOString().split("T")[0],
    ifsc: "",
    branchName: "",
  });

  // ---------------- Fetch Profile on Load -------------------------
  useEffect(() => {
    dispatch(fetchUserProfile());
  }, [dispatch]);

  // ✅ Fetch Schemes
  useEffect(() => {
    const fetchSchemes = async () => {
      try {
        const res = await axios.get(
          `https://payyug.in/api/get-all-saving-scheme?superAdminId=${profile?.superAdminId}`
        );
        if (res.data.success && Array.isArray(res.data.data)) {
          setSchemes(res.data.data);
          
        }
      } catch (err) {
        console.error("Error fetching schemes:", err);
      }
    };
    fetchSchemes();
  }, [profile?.superAdminId]);

  // ✅ Fetch Scheme Filter
  // useEffect(() => {
  //   const fetchSchemeDetails = async () => {
  //     if (!selectedScheme || !accountType) return;
  //     try {
  //       const res = await axios.get(
  //         "https://payyug.in/api/get-all-saving-scheme-filter",
  //         {
  //           params: { superAdminId: profile?.superAdminId, accountType },
  //         }
  //       );
  //       if (res.data.success && res.data.data) {
  //         const d = res.data.data;
  //         setFormData((prev) => ({
  //           ...prev,
  //           scheme: selectedScheme,
  //           interestRate: d.roi || "",
  //           initialDeposit: d.minOpeningBalance || "",
  //           cashWithdrawLimit: d.dailyCashLimit || "",
  //           fundTransferLimit: d.dailyFundLimit || "",
  //           // LockinAmount: d.locinAmount || "",
  //           // LockinAmount: d.locinAmount || "",
  //           schemeId: d.id || "",
  //         }));
         

  //         setPrefix(d.prefix || "");
  //       }
  //     } catch (error) {
  //       console.error("Error fetching filtered scheme:", error);
  //     }
  //   };
  //   fetchSchemeDetails();
  // }, [selectedScheme, accountType,profile?.superAdminId]);

  useEffect(()=>{
      setFormData((prev) => ({
            ...prev,
            scheme: selectedScheme,
            interestRate: selectedScheme.roi || "",
            initialDeposit: selectedScheme.minOpeningBalance || "",
            cashWithdrawLimit: selectedScheme.dailyCashLimit || "",
            fundTransferLimit: selectedScheme.dailyFundLimit || "",
            // LockinAmount: d.locinAmount || "",
            // LockinAmount: d.locinAmount || "",
            schemeId: selectedScheme.id || "",
          }));
  },[selectedScheme,profile?.superAdminId]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  // ✅ Auto-fetch referral name when Referral ID changes
  useEffect(() => {
    if (referId) fetchReferral();
  }, [referId,referType]);

 
  // ✅ Fetch Referral Employee Details
  // const fetchReferral = async () => {
  //   if (!referId) return toast.warn("Please enter a valid Referral ID");

  //   try {
  //     const superAdminId = profile?.superAdminId;
  //     const res = await axios.get("https://payyug.in/api/hr-employees-filter", {
  //       params: { userId: referId, superAdminId },
  //     });

  //     console.log("Referral API Response:", res.data);

  //     if (res.data.success && res.data.data) {
  //       const r = res.data.data;
  //       setReferralName(r.fullName || r.employeeName || r.name || ""); // use fullName safely
  //     } else {
  //       toast.error("No referral found with this ID");
  //       setReferralName("");
  //     }
  //   } catch (err) {
  //     console.error("Error fetching referral:", err);
  //     toast.error("Error fetching referral details");
  //     setReferralName("");
  //   }
  // };
  const fetchReferral = async () => {
    if (!referId) return toast.warn("Please enter a valid Referral ID");
    if (!referType) return toast.warn("Please select Referral Type");

    try {
      const superAdminId = profile?.superAdminId;

      // ✅ Select API based on referral type
      const apiUrl =
        referType === "Employee"
          ? "https://payyug.in/api/hr-employees-filter"
          : "https://payyug.in/api/customers-get-userId";

      const res = await axios.get(apiUrl, {
        params: { userId: referId, superAdminId },
      });

      // console.log("Referral API Response:", res.data);

      if (res.data.data) {
        const r = res.data.data;
        console.log("details are ", r);

        // Handle different response structures safely
        setReferralName(
          r.fullName ||
          r.employeeName ||
          r.customerName ||
          r.name ||
          ""
        );
        toast.success("data fetched successfully.");
      } else {
       if (referId.length > 8) {
          toast.error("No referral found with this ID");
        }
        setReferralName("");
      }
    } catch (err) {
      console.error("Error fetching referral:", err);
      // toast.error("Error fetching referral details");
      setReferralName("");
    }
  };

  // Mock fetch
  // ✅ Real API integration for fetching customer details
  // const fetchCustomer = async () => {
  //   if (!customerId) return;

  //   try {
  //     setCustomerLoading(true);

  //     const branchId = localStorage.getItem("userId") || "56"; // Use your branchId here
  //     const res = await axios.get(
  //       "https://payyug.in/api/customers-get-userId",
  //       {
  //         params: { userId: customerId, branchId },
  //       }
  //     );

  //     console.log("Customer API Response:", res.data);

  //     if (res.data && res.data.data) {
  //       const c = res.data.data;

  //       setCustomerData({
  //         name: c.fullName || "",
  //         email: c.email || "",
  //         phone: c.mobileNumber || "",
  //         aadhar: c.aadhaarNumber || "",
  //         pan: c.panNumber || "",
  //         address: c.address || "",
  //         dob: c.dateOfBirth ? c.dateOfBirth.split("T")[0] : "",
  //       });
  //     } else {
  //       // toast.error("No customer found with this ID");
  //     }
  //   } catch (err) {
  //     console.error("Error fetching customer:", err);
  //     // toast.error("Error fetching customer details");
  //   } finally {
  //     setCustomerLoading(false);
  //   }
  // };

    useEffect(() => {
      if (selectedCustomer) {
        setCustomerId(selectedCustomer.userId)
        setCustomerData((prev) => ({
          ...prev,
          name: selectedCustomer.fullName || "",
          email: selectedCustomer.email || "",
          phone: selectedCustomer.mobileNumber || "",
          aadhar: selectedCustomer.aadhaarNumber || "",
          pan: selectedCustomer.panNumber || "",
          address: selectedCustomer.address || "",
          dob: selectedCustomer.dateOfBirth ? selectedCustomer.dateOfBirth.split("T")[0] : "",
        
        }));
      } else if (!customerData.userId) {
        setCustomerData({
          userId: "",
          name:  "",
          email:  "",
          phone:"",
          aadhar:"",
          pan:"",
          address:"",
          dob:"",
        });
      }
    }, [selectedCustomer, customerData.userId]);

    const fetchCustomer = async () => {
        try {
          const res = await axios.get(`https://payyug.in/api/customers`, {
            params: {
              branchId: profile.id || 8,
              // superAdminId: profile.superAdminId || 14,
              page:1,
              limit:1000
            }
          });
          setCustomers(res.data.data || []);
        } catch (err) {
          toast.error(err?.response?.data?.message || "Failed to fetch customers");
        }
      };

        useEffect(() => {
    if (profile) fetchCustomer();
  }, [profile]);


  // ✅ Fetch nominee details using customerId filter
const fetchNominee = async () => {
    if (!customerId) return; 

    try {
      setNomineeLoading(true);
      const branchId = localStorage.getItem("userId") || "56";

      const res = await axios.get(
        "https://payyug.in/api/customer-nominee-filter",
        {
          params: { customerId, branchId },
        }
      );

      if (res.data.success && res.data.data) {
        const n = res.data.data;
        setNomineeData({
          nomineeName: n.nomineeName || "",
          dob: n.dateOfBirth ? n.dateOfBirth.split("T")[0] : "",
          aadhar: n.nomineeAadhar || "",
          pan: n.nomineePan || "",
          mobile: n.nomineeMobile || "",
          address: n.nomineeAddress || "",
        });
        setNomineeId(n.accountId || "");
        setRelation(n.nomineeRelation || n.relation || "");
      } else {
        // 🟢 AGAR NOMINEE NAHI MILA TOH FIELDS RESET KAREIN
        resetNomineeFields();
      }
    } catch (err) {
      console.error("Error fetching nominee:", err);
      // 🟢 ERROR KE CASE MEIN BHI FIELDS CLEAR KAREIN
      resetNomineeFields();
    } finally {
      setNomineeLoading(false);
    }
  };

  // 🟢 RESET FUNCTION (TAKI CODE REPEAT NA HO)
  const resetNomineeFields = () => {
    setNomineeData({
      nomineeName: "",
      dob: "",
      aadhar: "",
      pan: "",
      mobile: "",
      address: "",
    });
    setNomineeId("");
    setRelation("");
  };

  // ✅ Fetch nominee automatically when customer data fetched
useEffect(() => {
    if (customerId) {
      fetchNominee();
    } else {
      resetNomineeFields(); 
    }
  }, [customerId]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      // ✅ Use proper IDs
      const superAdminId = profile?.superAdminId || 14;
      const branchId = profile?.branchId || 8;
      const createdBy = localStorage.getItem("userId") || 56;

      // ✅ Prepare payload
      const payload = {
        superAdminId,
        branchId,
        createdBy,

        // ✅ Customer
        customerId,
        customerName: customerData.name || "--",

        // ✅ Nominee & Referral
        nomineeId: nomineeId || null,
        referId: referId || null,
        prefix: prefixData || null,

        // ✅ Scheme & Account Info
        accountType: accountType === "Saving Account" ? "Saving" : "Current",
        schemeId: formData.schemeId || null,
        interestRate: formData.interestRate || 0,
        initialDeposit: formData.initialDeposit || 0,
        openingBalance: formData.openingBalance || 0,
        cashWithdrawLimit: formData.cashWithdrawLimit || 0,
        fundTransferLimit: formData.fundTransferLimit || 0,
        // lockinAmount: formData.LockinAmount || 0,
        overdraftLimit: formData.overdraftLimit || 0,
        businessName: formData.businessName || "",
        gstNumber: formData.gstNumber || "",
        operationMode: formData.operationMode || "",
        openingDate:
          formData.openingDate,
        autoDebit: internetBanking ? 1 : 0,
      };

      console.log("🟢 Sending Payload:", payload);

      // ✅ API call
      const res = await axios.post(
        // "https://payyug.in/api/create-saving-account",
        "https://payyug.in/api/create-saving-account-aayog",
        payload
      );

      if (res.data.success) {
        toast.success(
          `${accountType} created successfully!\nAccount No: ${res.data.data.accountNumber}`
        );
        console.log("Account Created:", res.data.data);
        setCustomerData({
          name: "",
          email: "",
          phone: "",
          aadhar: "",
          pan: "",
          address: "",
          dob: "",
        });
        setNomineeData({
          nomineeName: "",
          dob: "",
          aadhar: "",
          pan: "",
          mobile: "",
          address: "",
        });
        setReferralName("");
        setreferId("");
        setFormData({
          accountType: "Saving Account",
          scheme: "",
          schemeId: 0,
          interestRate: "",
          initialDeposit: "",
          cashWithdrawLimit: "",
          fundTransferLimit: "",
          // LockinAmount: "",
          overdraftLimit: "",
          businessName: "",
          gstNumber: "",
          operationMode: "",
          openingDate: "",
          ifsc: "",
          branchName: "",
        });
      } else {
        toast.error("Failed to create account. Please try again.");
      }
    } catch (error) {
      console.error("Error creating saving account:", error);
      toast.error("Error while creating saving account.");
    }
  };
   console.log("prefix is ", prefixData);
  // console.log("selectedscheme",selectedScheme);

  // ====================== UI ======================
  return (
    <div className="saving-save-container">
      <h2 className="saving-title">
        {accountType === "Saving Account"
          ? "Saving Account Form"
          : "Current Account Form"}
      </h2>

      <form onSubmit={handleSubmit}>
        {/* ===== Account Info ===== */}

        <section className="saving-section">
          <h3>ACCOUNT INFORMATION</h3>
          <div className="saving-grid">
            {/* Account Type */}
            <div className="saving-row">
              <label>Account Type :</label>
              <select
                name="accountType"
                value={accountType}
                onChange={(e) => {
                  setAccountType(e.target.value);
                  setFormData({ ...formData, accountType: e.target.value });
                }}
              >
                <option value="Saving Account">Saving Account</option>
                <option value="Current Account">Current Account</option>
              </select>
            </div>

            {/* Scheme */}
            {/* <div className="saving-row">
              <label>Scheme Name :</label>
             <select
                value={selectedScheme ? schemes.indexOf(selectedScheme) : ""}
                onChange={(e) => {
                  const index = e.target.value;
                  setSelectedScheme(index !== "" ? schemes[index] : null);
                  setPrefix(selectedScheme.prefix);
                }}
              >
                <option value="">Select Scheme</option>
                {schemes.map((s, index) => (
                  <option key={s.id} value={index}>
                    {s.serviceName}
                  </option>
                ))}
              </select>
            </div> */}

            <div className="saving-row">
              <label>Scheme Name :</label>
              <select
                value={selectedScheme ? schemes.indexOf(selectedScheme) : ""}
                onChange={(e) => {
                  const index = e.target.value;
                  const scheme = index !== "" ? schemes[index] : null;

                  setSelectedScheme(scheme);
                  setPrefix(scheme ? scheme.prefix : "");
                }}
              >
                <option value="">Select Scheme</option>
                {schemes.map((s, index) => (
                  <option key={s.id} value={index}>
                    {s.serviceName}
                  </option>
                ))}
              </select>
            </div>

            {/* Common */}
            <div className="saving-row">
              <label>Initial Deposit :</label>
              <input
                type="number"
                name="initialDeposit"
                value={formData.initialDeposit}
                onChange={handleChange}
              />
            </div>

            <div className="saving-row">
              <label>Cash Withdrawal Limit :</label>
              <input
                type="number"
                name="cashWithdrawLimit"
                value={formData.cashWithdrawLimit}
                onChange={handleChange}
              />
            </div>

            <div className="saving-row">
              <label>Fund Transfer Limit :</label>
              <input
                type="number"
                name="fundTransferLimit"
                value={formData.fundTransferLimit}
                onChange={handleChange}
              />
            </div>

            {/* Saving Fields */}
            {accountType === "Saving Account" && (
              <>
                <div className="saving-row">
                  <label>Interest Rate (%):</label>
                  <input
                    type="number"
                    name="interestRate"
                    value={formData.interestRate}
                    onChange={handleChange}
                  />
                </div>
                {/* <div className="saving-row">
                  <label>Lock-in Amount :</label>
                  <input
                    type="number"
                    name="LockinAmount"
                    value={formData.LockinAmount}
                    onChange={handleChange}
                  />
                </div> */}
              </>
            )}

            {/* Current Fields */}
            {accountType === "Current Account" && (
              <>
                <div className="saving-row">
                  <label>Business Name :</label>
                  <input
                    type="text"
                    name="businessName"
                    value={formData.businessName}
                    onChange={handleChange}
                  />
                </div>
                <div className="saving-row">
                  <label>GST Number :</label>
                  <input
                    type="text"
                    name="gstNumber"
                    value={formData.gstNumber}
                    onChange={handleChange}
                  />
                </div>
                <div className="saving-row">
                  <label>Overdraft Limit (₹):</label>
                  <input
                    type="number"
                    name="overdraftLimit"
                    value={formData.overdraftLimit}
                    onChange={handleChange}
                  />
                </div>
              </>
            )}

            {/* Row 3 */}
            <div className="saving-row">
              <label>Opening Date :</label>
              <input
                type="date"
                name="openingDate"
                value={formData.openingDate}
                onChange={handleChange}
              />
            </div>
            {/* <div className="saving-row">
               <label>Bank IFSC Code :</label>
               <input type="text" name="ifsc" value={formData.ifsc} onChange={handleChange} />
             </div> */}
            <div className="saving-row">
              <label>Opening Balance :</label>
              <input
                type="text"
                name="openingBalance"
                required
                value={formData.openingBalance}
                onChange={handleChange}
              />
            </div>
          </div>
        </section>

        {/* ===== Customer Details (2 fields per row) ===== */}
        <section className="SavingNom-card">
          <h3>
            <FaUser /> Customer Details
          </h3>
          <div className="SavingNom-grid">
            <div>
              <label>Customer ID:</label>
              {/* <input
                type="text"
                placeholder="Enter Customer ID"
                value={customerId}
                onChange={(e) => setCustomerId(e.target.value)}
              /> */}
              <Select
              className="account-select-container"
              classNamePrefix="account-select"
              placeholder="Search Customer Id"
              options={customers.map((cus) => ({
                value: cus.id,
                label: `${cus.userId} | ${cus.fullName}`,
                customerDetail: cus,
              }))}
               value={
                selectedCustomer
                  ? {
                      value: selectedCustomer.id,
                      label: `${selectedCustomer.userId} | ${selectedCustomer.fullName}`,
                    }
                  : null
              }
              onChange={(selected) => setSelectedCustomer(selected?.customerDetail)}
              isSearchable
              />
            </div>

            <div>
              <label>User Name:</label>
              <input
                type="text"
                value={customerData.name}
                onChange={(e) =>
                  setCustomerData({ ...customerData, name: e.target.value })
                }
              />
            </div>

            <div>
              <label>Email:</label>
              <input
                type="email"
                value={customerData.email}
                onChange={(e) =>
                  setCustomerData({ ...customerData, email: e.target.value })
                }
              />
            </div>

            <div>
              <label>Phone:</label>
              <input
                type="text"
                value={customerData.phone}
                onChange={(e) =>
                  setCustomerData({ ...customerData, phone: e.target.value })
                }
              />
            </div>

            <div>
              <label>Aadhar:</label>
              <input
                type="text"
                value={customerData.aadhar}
                onChange={(e) =>
                  setCustomerData({ ...customerData, aadhar: e.target.value })
                }
              />
            </div>

            <div>
              <label>PAN:</label>
              <input
                type="text"
                value={customerData.pan}
                onChange={(e) =>
                  setCustomerData({ ...customerData, pan: e.target.value })
                }
              />
            </div>

            <div>
              <label>Date of Birth:</label>
              <input
                type="date"
                value={customerData.dob}
                onChange={(e) =>
                  setCustomerData({ ...customerData, dob: e.target.value })
                }
              />
            </div>

            <div className="full-width">
              <label>Address:</label>
              <input
                type="text"
                value={customerData.address}
                onChange={(e) =>
                  setCustomerData({ ...customerData, address: e.target.value })
                }
              />
            </div>
          </div>
        </section>

        {/* ===== Nominee Details (2 fields per row) ===== */}
        <section className="SavingNom-card">
          <h3>
            <FaUserFriends /> Nominee Details
          </h3>

          <div className="SavingNom-grid">
            <div>
              <label>Nominee ID:</label>
              <input
                type="text"
                placeholder="Enter Nominee ID"
                value={nomineeId}
                onChange={(e) => setNomineeId(e.target.value)}
              />
            </div>

            <div>
              <label>Nominee Name:</label>
              <input
                type="text"
                value={nomineeData.nomineeName}
                onChange={(e) =>
                  setNomineeData({
                    ...nomineeData,
                    nomineeName: e.target.value,
                  })
                }
              />
            </div>

            <div>
              <label>DOB:</label>
              <input
                type="date"
                value={nomineeData.dob}
                onChange={(e) =>
                  setNomineeData({ ...nomineeData, dob: e.target.value })
                }
              />
            </div>

            <div>
              <label>Aadhar:</label>
              <input
                type="text"
                value={nomineeData.aadhar}
                onChange={(e) =>
                  setNomineeData({ ...nomineeData, aadhar: e.target.value })
                }
              />
            </div>

            <div>
              <label>PAN:</label>
              <input
                type="text"
                value={nomineeData.pan}
                onChange={(e) =>
                  setNomineeData({ ...nomineeData, pan: e.target.value })
                }
              />
            </div>

            <div>
              <label>Mobile:</label>
              <input
                type="text"
                value={nomineeData.mobile}
                onChange={(e) =>
                  setNomineeData({ ...nomineeData, mobile: e.target.value })
                }
              />
            </div>

            {/* <div>
      <label>Relation:</label>
      <select
        value={relation}
        onChange={(e) => setRelation(e.target.value)}
      >
        <option value="">Select</option>
        <option value="Father">Father</option>
        <option value="Mother">Mother</option>
        <option value="Spouse">Spouse</option>
        <option value="Son">Son</option>
        <option value="Daughter">Daughter</option>
      </select>
    </div> */}

            <div>
              <label>Relation:</label>
              <select
                value={relation}
                onChange={(e) => setRelation(e.target.value)}
              >
                <option value="">Select</option>
                {["Father", "Mother", "Spouse", "Son", "Daughter", relation]
                  .filter((r, i, arr) => r && arr.indexOf(r) === i) // remove duplicates
                  .map((r) => (
                    <option key={r} value={r}>
                      {r}
                    </option>
                  ))}
              </select>
            </div>

            {/* 
    <div className="full-width">
      <label>Address:</label>
      <input
        type="text"
        value={nomineeData.address}
        onChange={(e) =>
          setNomineeData({ ...nomineeData, address: e.target.value })
        }
      />
    </div> */}
          </div>
        </section>

        {/* ===== Referral ===== */}
        <section className="SavingRef-card">
          <h3>
            <FaIdBadge /> Referral Details
          </h3>
          <div className="SavingRef-row-horizontal">

            <div>
              <label>Referral Person:</label>
              <select
                value={referType}
                onChange={(e) => setReferType(e.target.value)}
              >
                <option value="">Select Referral Type</option>
                <option value="Customer">Customer</option>
                <option value="Employee">Employee</option>
              </select>
            </div>


            <div>
              <label>Referral ID:</label>
              <input
                type="text"
                placeholder="Enter Referral ID"
                value={referId}
                onChange={(e) => setreferId(e.target.value)}
              />
            </div>

            <div>
              <label>Referral Name:</label>
              <input
                type="text"
                value={referralName}
                readOnly
                placeholder="Auto-filled after ID"
              />
            </div>
          </div>
        </section>
        <div style={{ textAlign: "center" }}>
          <button type="submit" className="savingsubmit-btn">
            Open {accountType}
          </button>
        </div>
      </form>
    </div>
  );
};

export default SavingAccountForm;
